/** public/images/icons 渠道图标 */
export const SUPPORTED_CHANNELS = [
  { id: 'whatsapp', name: 'WhatsApp', icon: '/images/icons/WhatsApp.png' },
  { id: 'messenger', name: 'Messenger', icon: '/images/icons/Messenger.png' },
  { id: 'instagram', name: 'Instagram', icon: '/images/icons/Instagram.png' },
  { id: 'telegram', name: 'Telegram', icon: '/images/icons/Telegram.png' },
  { id: 'tiktok', name: 'TikTok', icon: '/images/icons/TikTok.png' },
  // { id: 'wechat', name: 'WeChat', icon: '/images/icons/weixin.png' },
  { id: 'LINE', name: 'LINE', icon: '/images/icons/line.png' },
  { id: 'x', name: 'X', icon: '/images/icons/X.webp' },
  { id: 'youtube', name: 'YouTube', icon: '/images/icons/YouTube.png' },
  { id: 'zalo', name: 'Zalo', icon: '/images/icons/Zalo.png' },
];

/** Hero 模拟工作台侧边栏渠道 */
export const HERO_MOCKUP_CHANNELS = [
  { id: 'whatsapp', labelKey: 'hero.channel1', icon: '/images/icons/WhatsApp.png' },
  { id: 'facebook', labelKey: 'hero.channel2', icon: '/images/icons/Messenger.png' },
  { id: 'instagram', labelKey: 'hero.channel3', icon: '/images/icons/Instagram.png' },
  { id: 'email', labelKey: 'hero.channel4', materialIcon: 'mail' },
];
